<!--Copyright Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<span class="token-picker-field-box" *ngIf="!isDynamic else dynamic" [ngClass]="{'extra-space': !getBrokenValidationRule()}">
  <mat-form-field *ngIf="showTokenTextBox" title="{{lf_field_info.displayName}}" appearance="outline" class="lf-field">
    <input #tokenTarget matInput type="text" [formControl]="lf_field_form_control"
      title="{{lf_field_form_control.value}}" (change)="onTimeValueChangedAsync()">
  </mat-form-field>
  <lf-uni-date-time #tokenTarget class="lf-field" *ngIf="!showTokenTextBox" [config]="uniDateTimeConfig"
    [settings]="uniDateTimeSettings" (valueChangedEventHandler)="onUniDateOrTimeChanged($event)">
  </lf-uni-date-time>
  <lf-token-picker-component class="lf-field-token-picker" (tokenPicked)="onTimeTokenChosen($event)"
    [data]="lfFieldTokenData">
  </lf-token-picker-component>
</span>
<mat-error *ngIf="getBrokenValidationRule()">{{fieldValidationErrorMsg | async}}</mat-error>

<ng-template #dynamic>
  <lf-dynamic-field-component ngDefaultControl [options]="dynamic_field_value_options"
    [formControl]="lf_field_form_control" [title]="lf_field_info.displayName"
    [fieldValidationErrorMsg]="fieldValidationErrorMsg" [getBrokenValidationRule]="getBrokenValidationRule.bind(this)"
    (valueChange)="onValueChanged()">
  </lf-dynamic-field-component>
</ng-template>
